import * as angular from "angular";
import "./veriMapSingleGeofence.scss";

import { GeofenceService } from "@services/geofence.service";
import { IGeofence } from "@interfaces/IGeofences";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";

class VeriMapSingleGeofenceComponentController implements angular.IComponentController {
    veriMap: IVeriMapComponent;
    geofence: IGeofence;
    geofences: IGeofence[] = [];

    static $inject = ["geofenceService"];

    constructor(
        private readonly geofenceService: GeofenceService
    ) { }

    $onInit() {
        this.fitmap();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (onChangesObj["geofence"]) {
            this.fitmap();
        }
    }

    $onDestroy() {
        this.mapUnloaded();
    }

    mapLoaded(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;
        this.fitmap();
    }

    mapUnloaded() {
        this.veriMap = null;
    }

    private fitmap() {
        this.geofenceService.fitMapToGeofences(this.veriMap, this.geofence, this.geofences);
    }

}

export class VeriMapSingleGeofenceComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: { [slot: string]: string };

    constructor() {
        this.bindings = {
            geofences: "<",
            geofence: "<"
        };

        this.controller = VeriMapSingleGeofenceComponentController;
        this.template = require("./veriMapSingleGeofence.html");
    }
}
